import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkCreateIcd10Codes } from '../types';

// @ts-ignore
const onCreateIcd10Codes: IThunkCreateIcd10Codes = thunk(async ({ addIcd10Codes }, payload) => {
  const icd10Codes = await api.icd10Codes.createBulk(payload).then(res => res.data);
  addIcd10Codes(icd10Codes);
});

export default onCreateIcd10Codes;
